module.exports = __webpack_public_path__ + "static/media/KF2_KFInc_KeyArt_Flats.350426b4.jpg";